import React, { useState } from "react";

const AddPublication = () => {
  const [formData, setFormData] = useState({
    title: "",
    abstract: "",
    uploadedFile: null,
    authors: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };



  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setFormData({
      ...formData,
      uploadedFile: file,
    });
  };

  const handleCancel = () => {
    setFormData({
      title: "",
      abstract: "",
      uploadedFile: null,
      authors: "",
    });
  };

  const handleSave = () => {
    console.log("Form Data:", formData);
    if (formData.uploadedFile) {
      console.log("Uploaded File:", formData.uploadedFile.name);
    }
    alert("Publication saved successfully!");
  };

  return (
    <div className="mx-5 mt-5">
      {/* Breadcrumb */}
      <div className="flex items-center text-[25px]">
        <span className="text-gray-400">Research & Student Life</span> /{" "}
        <p className="font-semibold">Research Publications</p>
      </div>

      {/* Add and List Buttons */}
      <div className="flex items-center gap-3 mt-5">
        <button className="flex items-center gap-2 bg-[#6B1FBA] text-white px-4 py-2 rounded-lg">
          Add New Publication
        </button>
        <button className="flex items-center gap-2 bg-gray-200 text-gray-700 px-4 py-2 rounded-lg">
          List Table
        </button>
      </div>

      <div className="mt-8 bg-white shadow-md rounded-lg p-8">
        <h2 className="text-2xl font-semibold mb-6">Add Publication</h2>

        <div className="mb-4">
          <label className="block text-gray-600 mb-2">Title</label>
          <input
            type="text"
            name="title"
            value={formData.title}
            onChange={handleChange}
            className="w-full border border-gray-300 rounded px-4 py-2"
            placeholder="Enter publication title"
          />
        </div>

        <div className="mb-4">
          <label className="block text-gray-600 mb-2">Abstract</label>
          <textarea
            name="abstract"
            value={formData.abstract}
            onChange={handleChange}
            className="w-full border border-gray-300 rounded px-4 py-2"
            rows="5"
            placeholder="Enter publication abstract"
          ></textarea>
        </div>

        <div className="mb-4">
          <label className="block text-gray-600 mb-2">Upload Documents</label>
          <div className="flex items-center gap-2">
            <input
              type="file"
              onChange={handleFileChange}
              className="w-full border border-gray-300 rounded px-4 py-2"
            />
            {formData.uploadedFile && (
              <span className="text-sm text-gray-600">
                {formData.uploadedFile.name}
              </span>
            )}
          </div>
        </div>

        <div className="mb-4">
          <label className="block text-gray-600 mb-2">Authors</label>
          <input
            type="text"
            name="authors"
            value={formData.authors}
            onChange={handleChange}
            className="w-full border border-gray-300 rounded px-4 py-2"
            placeholder="Enter authors"
          />
        </div>

        {/* Buttons */}
        <div className="flex justify-end gap-4">
          <button
            type="button"
            onClick={handleCancel}
            className="bg-gray-200 text-gray-700 px-4 py-2 rounded-lg"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={handleSave}
            className="bg-[#6B1FBA] text-white px-4 py-2 rounded-lg"
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddPublication;
